module.exports = __webpack_public_path__ + "static/media/plans-bg.db977368.svg";